import axios from 'axios';
import API_BASE_URL from '../config';


const API = axios.create({
    baseURL: API_BASE_URL, // آدرس پایه API
});

API.interceptors.request.use((config) => {
    config.withCredentials = true;
    const token = window.localStorage.getItem("token");
    if (token) {
        config.headers["X-CSRFToken"] = token;
    }
    return config;
});

export async function ensureCsrfToken() {
    try {
        const response = await API.get("/csrf/");
        const token = response.data && response.data.csrf_token;
        if (token) {
            window.localStorage.setItem("token", token);
        }
        return token || window.localStorage.getItem("token");
    } catch {
        return window.localStorage.getItem("token");
    }
}

export default API;
